import {
  CylinderGeometry,
  DoubleSide,
  Group,
  Mesh,
  MeshBasicMaterial,
  MeshStandardMaterial,
  RingGeometry
} from 'three';
import { getAltarPosition } from '../../domain/map/ttAltarRules.js';

/**
 * altarSceneManager — Visual meshes for TT altars (no gameplay formulas).
 *
 * Contrato:
 *   getAltarVisualState(altar) → { color, progress }
 *   createAltarMeshes(altars) → { altarId, group, pedestal, ring }[]
 *   syncAltarMeshes(meshEntries, altars)
 */

const TEAM_COLORS = {
  blue: 0x3b82f6,
  red: 0xef4444,
  neutral: 0x94a3b8
};

export function getAltarVisualState(altar) {
  const owner = altar?.teamOwner || altar?.capturedBy || null;
  const color = TEAM_COLORS[owner] || TEAM_COLORS.neutral;
  const progress = altar?.captureProgress || 0;
  return { color, progress };
}

export function createAltarMeshes(altars = []) {
  return altars.map(altar => {
    const pos = getAltarPosition(altar);
    const visual = getAltarVisualState(altar);
    const group = new Group();

    const pedestal = new Mesh(
      new CylinderGeometry(0.9, 1.1, 0.35, 16),
      new MeshStandardMaterial({ color: visual.color, emissive: visual.color, emissiveIntensity: 0.25 })
    );
    pedestal.position.y = 0.18;
    group.add(pedestal);

    const ring = new Mesh(
      new RingGeometry(1.0, 1.2, 32).rotateX(-Math.PI / 2),
      new MeshBasicMaterial({
        color: visual.color,
        side: DoubleSide,
        transparent: true,
        opacity: 0.55
      })
    );
    ring.position.y = 0.05;
    group.add(ring);

    group.position.set(pos.x, 0, pos.y);
    return { altarId: altar.id, group, pedestal, ring };
  });
}

export function syncAltarMeshes(meshEntries = [], altars = []) {
  meshEntries.forEach(entry => {
    const altar = altars.find(a => a.id === entry.altarId);
    if (!altar) return;
    const visual = getAltarVisualState(altar);
    if (entry.pedestal?.material) {
      entry.pedestal.material.color.setHex(visual.color);
      entry.pedestal.material.emissive.setHex(visual.color);
    }
    if (entry.ring?.material) {
      entry.ring.material.color.setHex(visual.color);
      entry.ring.material.opacity = 0.35 + visual.progress * 0.5;
    }
  });
}
